import { createSlice } from "@reduxjs/toolkit";

import { ReduxReducer } from "../../../../interface";
import { DEFAUT_VALUEE_FILTERS } from "../../../../../components/common/Modal/ArchiveOrderFiltersModal/constants";
import { Customers } from "../../interface";

import { State, OrdersData } from "./interface";

const initialState: State = {
	orders: {},
};

const setOrdersDataModal: ReduxReducer<State, State["orders"]> = (
	state,
	action,
) => {
	for (const [id, data] of Object.entries(action.payload)) {
		const numericId = Number(id);

		if (!Number.isNaN(numericId)) {
			const existing = state.orders[numericId];
			state.orders[numericId] = {
				...(existing ?? { byMultyFilters: DEFAUT_VALUEE_FILTERS }),
				...data,
			};
		}
	}
};

const setByMultyFilters: ReduxReducer<
	State,
	{ id?: number; filters?: OrdersData["byMultyFilters"] }
> = (state, action) => {
	const { id, filters } = action.payload;
	const numericId = Number(id);

	if (Number.isNaN(numericId) || !filters) return;

	const existing = state.orders[numericId];

	state.orders[numericId] = {
		...(existing ?? { models: [] }),
		byMultyFilters: filters,
	};
};

const customersCounterpartiesDataModal = createSlice({
	name: Customers.ConstantCustomersSlice.COUNTERPARTIES_DATA_MODAL,
	initialState,
	reducers: {
		setOrdersDataModal,
		setByMultyFilters,
	},
});

export const customersCounterpartiesDataModalAction =
	customersCounterpartiesDataModal.actions;
export const customersCounterpartiesDataModalReducer =
	customersCounterpartiesDataModal.reducer;
export type customersCounterpartiesDataModalState = State;

export default customersCounterpartiesDataModal;
